<template>
    <v-container class="pa-0">

        <div class="chats-header">
            <back-button class="chats-back" />
            <h1 class="chats-title">{{ $tc('common.messages', 2) }}</h1>
            <kimsa-text-field class="chats-search" :placeholder="$t('common.search')" :value="search"
                @change="search = $event" icon="mdi-magnify" dense clearable />
        </div>

        <skeleton-loader v-if="loading" type="chat-list" :count="6" class="mt-1" />

        <template v-else>
            <div v-if="chatsFiltered.length === 0" class="chats-empty">
                <v-icon size="34" color="txtMuted">mdi-message-text-outline</v-icon>
                <span>{{ chats.length === 0 ? $t('common.no_chat_history') : $t('common.no_results') }}</span>
            </div>
            <div v-else class="chats-grid">
                <student-chat-card v-for="chat in chatsFiltered" :key="chat.id" @click="onShowChat(chat)"
                    :chat="chat" />
            </div>
        </template>

        <chat-dialog @hideChat="onHideChat" :clientId="studentId" ref="chat" />

    </v-container>
</template>

<script>

import StudentChatCard from '@/components/common/cards/StudentChatCard'
import ChatDialog from '@/components/student/ChatDialog'
import { db, getAllByIds } from '@/utils/Firebase'
import _map from 'lodash/map'
import _flatten from 'lodash/flatten'
import _uniq from 'lodash/uniq'
import BackButton from "@/components/common/BackButton";
import KimsaTextField from "@/components/common/inputs/KimsaTextField";
import SkeletonLoader from '@/components/common/SkeletonLoader'

export default {
    components: {
        KimsaTextField,
        BackButton,
        StudentChatCard,
        ChatDialog,
        SkeletonLoader,
    },
    data() {
        return {
            loading: false,
            chats: [],
            studentId: null,
            search: '',
        }
    },
    computed: {
        chatsFiltered(vm = this) {
            if (!vm.search || vm.search.length < 3) return vm.chats
            return vm.chats.filter(chat =>
                chat.participants.some(participant =>
                    participant.name?.toLowerCase().includes(vm.search.toLowerCase()) || participant.email?.toLowerCase().includes(vm.search.toLowerCase())
                )
            )
        }
    },
    mounted() {
        const vm = this
        vm.loadChats()
    },
    methods: {
        async loadChats() {
            const vm = this
            await vm.withLoading(async () => {
                let allChats = []

                let chatRef = await db.collection('privateChats')
                    .where('participants', 'array-contains', vm.currentUser.uid)
                    .get()

                chatRef.docs.forEach(chat => {
                    allChats.push({
                        ...chat.data(),
                        id: chat.id
                    })
                })

                const allParticipantIDs = _uniq(_flatten(_map(allChats, 'participants'))).filter(id => !!id)
                let allUsers = []

                if (allParticipantIDs.length > 0) {
                    allUsers = await getAllByIds('users', allParticipantIDs)
                }

                for (let chat of allChats) {
                    if (chat.lastMessage) chat.lastMessage.from = allUsers.find(user => user.objectID === chat.lastMessage.from)
                    chat.participants = allUsers.filter(user => chat.participants.includes(user.objectID))
                }

                vm.chats = allChats.filter(chat => chat.lastMessage?.from)

                const messagesNoRead = vm.chats.filter(chat => chat.lastMessage?.from?.objectID !== vm.currentUser.uid && !chat.lastMessage?.read).length
                const myMessagesNoRead = vm.account?.counter?.messages || 0
                if (messagesNoRead !== myMessagesNoRead) await db.collection('users').doc(vm.currentUser.uid).update({ 'counter.messages': messagesNoRead })
            })
        },
        onShowChat(chat) {
            const vm = this
            let notMe = chat.participants.find(usr => usr.objectID !== vm.currentUser.uid)
            vm.studentId = notMe?.objectID || null
            vm.$refs.chat.show()
        },
        onHideChat(payload = {}) {
            const vm = this
            vm.studentId = null

            const closedChatId = payload?.chatId
            if (!closedChatId) return

            const chat = vm.chats.find(c => c.id === closedChatId)
            if (!chat?.lastMessage) return

            const fromId = chat.lastMessage.from?.objectID || chat.lastMessage.from
            const wasUnreadFromOther = fromId !== vm.currentUser.uid && !chat.lastMessage.read
            if (!wasUnreadFromOther) return

            // El contador lo recalcula onChatWrite al marcar lastMessage.read;
            // aca solo se refresca el estado local de la tarjeta.
            vm.$set(chat.lastMessage, 'read', true)
        }
    },
}
</script>

<style scoped>
.chats-header {
    display: flex;
    align-items: center;
    gap: 14px;
    flex-wrap: wrap;
    margin-bottom: 18px;
}

.chats-back {
    flex-shrink: 0;
}

.chats-title {
    font-size: 22px;
    font-weight: 700;
    color: var(--v-txtPrimary-base);
    margin: 0;
}

.chats-search {
    width: 240px;
    margin-left: auto;
}

.chats-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 12px;
}

.chats-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    padding: 48px 0;
    color: var(--v-txtMuted-base);
    font-size: 14px;
}

@media (max-width: 600px) {
    .chats-title {
        font-size: 20px;
    }

    .chats-search {
        width: 100%;
        margin-left: 0;
    }
}
</style>
